export class EmailViewProperties {
    public Title: string;
    public FieldLabel: string;
    public SubmitButtonText: string;
    public CancelButtonText: string;
    public ReadOnly: boolean;
}
